import moment from 'moment';
export default {
    FormatDateTime: function (date) {
        return moment(date).format('DD/MM/YYYY HH:mm');
    },

    FormatDate: function (date) {
        return moment(date).format('DD/MM/YYYY');
    },

    FormatPrice: function (price) {
        let price_ = price.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(',');
        if (price_.length === 1) {
            price_[1] = "00";
        } else if (price_[1].length === 1) {
            price_[1] = price_[1] + "0";
        }
        return price_.join(',');
    }
}



// WEBPACK FOOTER //
// ./src/functions/functions.js